export default __webpack_public_path__ + "static/Hero_07_Planning-eb0bdf0063601a185d638fcdad021f3f.jpg";